<template>
  <v-dialog @input="closed()" :value="alertModalIsShow" width="400px">
    <v-card>
      <v-card-text>地点グループを選択してください。</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="info" @click="click()">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getters, actions } from '@/vuex/modules/pointGroupCatalog/constants'

export default {
  name: 'AlertModal',
  computed: {
    alertModalIsShow() {
      return this.$store.getters[getters.alertModalIsShow]
    },
  },
  methods: {
    // 背景をclickして閉じた場合は@inputが発火するので、
    // それを検知してvuexの値を更新する
    closed() {
      const isShow = false
      this.$store.dispatch(actions.SET_ALERT_MODAL_IS_SHOW, { isShow })
    },
    click() {
      const isShow = false
      this.$store.dispatch(actions.SET_ALERT_MODAL_IS_SHOW, { isShow })
    },
  },
}
</script>

<style scoped></style>
